// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { CreateAlertAccountLookupTemplate } from '../../../templates';
import { ContainerControl } from '../../elements/ContainerControl';
import { Resources } from '../../../Commons/properties/Resources';
import { ControlsTypes } from '../../UtilsClasses/FactoryConstants';
import { DataCache } from '../../../Commons/DataCache';
import { LinkedSystem } from '../../misc/LinkedSystem';

export class CreateAlertAccountLookup extends ContainerControl.extend({
    template: CreateAlertAccountLookupTemplate,
    data: function () {
        return {
            label: '',
            name: ControlsTypes.CreateAlertAccountLookup,
            account: null
        };
    }
}) {
    Controls: any;
    getType (): string { return ControlsTypes.CreateAlertAccountLookup; }

    oninit (): void {
        ContainerControl.prototype.oninit.call(this);
        Resources.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }

    oncomplete (): void {
        ContainerControl.prototype.oncomplete.call(this);
        this.updateEnabledState();
    }

    updateEnabledState (): void {
        const accountLookup = this.Controls.TerceraAccountLookup;
        if (accountLookup != null) {
            const ignore: boolean = accountLookup.get('ignoreForceLinkingByAccount');
            const onlyOwnAccounts: boolean = accountLookup.get('onlyOwnAccounts');
            const forceLinking = DataCache.EnableForceLinkingByAccount();

            if (forceLinking && ignore && onlyOwnAccounts) { // special logic for CreateAlertAccountLookup https://docs.google.com/document/d/1bInvXAY45OMK3SZm0lyYuJywLv1GQA08zYBrVJwGsEM/edit
                const acc = DataCache.GetAccountById(LinkedSystem.getAccount());
                const accountIsNotOwnedByUser = acc != null ? !acc.IsOwnedByUser : true;

                accountLookup.set('enabled', accountIsNotOwnedByUser);
                if (accountIsNotOwnedByUser) {
                    accountLookup.setItems(DataCache.getOwnedAccounts());

                    const newAcc = accountLookup.items[0];
                    if (newAcc != null) {
                        accountLookup.setSelectValue(newAcc);
                    }
                } else {
                    accountLookup.setSelectValue(acc);
                }
            }
        }
    }

    dispose (): void {
        Resources.onLocaleChange.UnSubscribe(this.localize, this);
        ContainerControl.prototype.dispose.call(this);
    }

    localize (): void {
        super.set('label', Resources.getResource('screen.Alerts.Label.Account'));
    }
}
